






import { Component, Vue, Prop } from "vue-property-decorator";
import { ChartColors, ChartConstants } from "@/constants/chart";
import InfoTooltip from '@/components/infoTooltip/InfoTooltip.vue';

@Component({
  name: "CreditScoreRender",
  components: {
    InfoTooltip,
  },
})
export default class CreditScoreRender extends Vue {

  @Prop({ type: Number, required: true })
  private score!: number;

  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: Boolean, default: false })
  private main!: boolean;

  @Prop({ type: String, required: true })
  private scoreName!: string;

  get chartOptions() {
    const context = this;
    return {
      chart: {
        type: 'solidgauge',
        width: 215,
        height: 130,
        backgroundColor: ChartColors.BACKGROUND,
        style: {
          fontFamily: ChartConstants.FONT_FAMILY
        },
      },

      title: {
        text: `${this.title} <span id="info-window-${this.scoreName}"></span>`,
        style: this.main? ChartConstants.TITLE_STYLE_BOLD: ChartConstants.TITLE_STYLE,
        align: 'left',
        useHTML: true,
      },

      pane: {
        center: ['45%', '85%'],
        size: this.main ? '170%': '130%',
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: ChartColors.WHITE,
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }
      },

      exporting: {
        enabled: false
      },

      tooltip: {
        enabled: false
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        stops: [
            [0.1, ChartColors.GAUGE_RED],
            [0.5, ChartColors.GAUGE_YELLOW],
            [0.9, ChartColors.GAUGE_GREEN] 
        ],
        
        lineWidth: 0,
        tickWidth: 0,
        minorTickInterval: null,
        tickAmount: 2,
        labels: false
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            borderWidth: 0,
            useHTML: true
          }
        }
      },

      credits: {
        enabled: false
      },

      series: [{
        name: 'score',
        data: [this.score],
        dataLabels: {
          format:
            `
            <div style="text-align:center; position: relative; top: 8px">
              <span style="font-size: 18px; font-weight: ${this.main ? '900' : '400'}">{y}</span><br/>
            </div>
            `
        }
      }],

      responsive: {
        rules: [{
          condition: {
              maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    } 
  }

  private mounted() {
    new InfoTooltip({propsData: {title: this.$t(`info-tooltip.credit-trust.${this.scoreName}`), tooltipPlacement: 'bottom', iconSize: 12, iconClass: 'terracota'}})
    .$mount(document.querySelector(`#info-window-${this.scoreName}`)!);
  }
}

